import lazyLoadOnRender from '../../lazy/loadOnRender';

const AppNavigation = () => import(/* webpackChunkName: "4-feat-appnavigation" */ './AppNavigation');

export default lazyLoadOnRender({ loader: AppNavigation });
